import React from "react";
import "../mspMembersAccess.scss";
import MultiSelectDropdown from "../../../AttackSurface/AttackComponents/MultiSelectDropdown";
import ImageWithInitials from "../../../../Utils/ImageWithInitials";
import { getAPIData } from "../../../../Utils/commonApi";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import { useAuth } from "../../../context/Auth";
import { Button } from "react-bootstrap";

const AssignedUsersBlock = ({
  data = [],
  members = [],
  selectedMembers = [],
  dontAllowEdit = false,
  adding = false,
  passedOptionEnum99,
  onItemClick = (value) => { },
  getMembersDetails = () => { },
  inviteMember = () => { }
}) => {
  const { authTokens } = useAuth();

  async function handleDeleteUser(userId) {
    await getAPIData("570", authTokens, passedOptionEnum99 ? {
      optionEnum1: userId,
      optionEnum99: passedOptionEnum99,
    }: {
      optionEnum1: userId,
      optionEnum99: 5,
    }).then((response) => {
      if (response.Success) {
        getMembersDetails();
        CallToast("Member deleted successfully", false, false, "v2style");
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
    });
  }

  return (
    <>
      {data?.length > 0 && (
        <div className="border-top mt-24px">
          <div className="f-12 f-darkgrey mt-16px">Assigned users</div>
          {
            !dontAllowEdit &&
            <div className="bg-grey d-flex align-items-center radius-4 grey-border flex-grow-1 mr-1 highlight-input-with-grey-border">
              <div className="bg-grey w-100 border-none pl-2 my-1" tabIndex={-1} >
                <MultiSelectDropdown
                  data={data?.length > 0 ? members?.filter(memb => !data?.some(user => user?.userId === memb?.userId)) : members}
                  selected={selectedMembers}
                  placeholder={"Add members"}
                  placeholderIcon={<img alt="" className="mr-2" src="/images/msp/integrations/add-user-icon-msp.svg" />}
                  onChange={(val) => { onItemClick(val); }}
                />
              </div>
              <div className="w-fit-content dropdown-grey-theme score-question-dropdown ml-3 w-70" style={{ alignSelf: 'flex-end', marginBottom: '5px' }}>
                {selectedMembers.length > 0 && <Button className="hg-cancel-btn" onClick={() => { inviteMember() }}>
                  {adding ? "Adding..." : "Add"}
                </Button>}
              </div>

            </div>
          }
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {data?.map(item => {
              return (
                <UserItem
                  dontAllowEdit={dontAllowEdit}
                  showInitials={item.showInitials}
                  initials={item.initials}
                  image={item.ImageURL}
                  fullName={item.fullName}
                  onDeleteClick={() => { handleDeleteUser(item.userId) }}
                />
              )
            })}
            {(data?.length <= 0 && dontAllowEdit) && <div className="f-darkgrey f-14 f-400 mt-2" style={{ marginBottom: '-8px !important' }}>No users assigned</div>}
          </div>
        </div>
      )}
    </>
  );
};

export default AssignedUsersBlock;

const UserItem = ({
  dontAllowEdit = false,
  showInitials = false,
  initials = '',
  image = '',
  fullName = '',
  onDeleteClick = () => { }
}) => (
  <div>
    <div className={`d-flex align-items-center justify-content-between my-1 radius-4 hover-on-show-parent p-2 px-3 ${dontAllowEdit ? 'cursor-default' : 'bg-hover-grey pointer'}`}>
      <div className="d-flex align-items-center w-100" style={{ justifyContent: "space-between" }}>
        <div className="d-flex align-items-center  ">
          {showInitials ? (<ImageWithInitials initials={initials} width={30} background={"purple"} />) : (
            <img alt="" src={`/images/${image}`} className="" style={{ width: "30px", borderRadius: "50%", objectFit: "contain" }} />
          )}
          <div className="f-500 f-grey ml-2">{fullName}</div>
        </div>
        {
          !dontAllowEdit && <div className="hover-on-show-child" onClick={onDeleteClick}>
            <img src="/images/attack-surface/cross-icon.svg" alt="" />
          </div>
        }
      </div>
    </div>
  </div>
)